import React from 'react';
import { Form, Field } from 'react-final-form';
import {
  FormGroup,
  InputGroup,
  Button,
  ButtonToolbar,
  ControlLabel,
  FormControl,
} from 'react-bootstrap';
import zxcvbn from 'zxcvbn';

import { required } from '../../../forms';

export const passwordStrength = (value) => {
  const score = zxcvbn(value);
  switch (score.score) {
    case 0:
      return { className: 'alert alert-danger', msg: 'Very Weak!' };
    case 1:
      return { className: 'alert alert-danger', msg: 'Weak!' };
    case 2:
      return { className: 'alert alert-warning', msg: 'You can do better!' };
    case 3:
      return { className: 'alert alert-info', msg: 'Good!' };
    case 4:
      return { className: 'alert alert-success', msg: 'Great!' };
    default:
      return undefined;
  }
};

const validate = (values) => {
  const errors = {}
  if (!values.password) {
    errors.password = 'Required';
  }
  if (values.password != values.password2) {
    errors.password2 = 'Passwords do not match';
  }
  return errors;
};

export const renderBootstrapField = ({ input, label, type, meta: { touched, error, warning } }) => (
  <InputGroup>
    { label && (<ControlLabel>{label}</ControlLabel>)}
    <FormControl
      {...input}
      type={type}
    />
    {touched &&
      ((error && <p className="alert alert-danger">{error}</p>) ||
        (warning && <p className={warning.className}>{warning.msg}</p>))}

  </InputGroup>
);

const PasswordForm = ({ onSubmit, initialValues, onClose }) => (
  <Form
    onSubmit={onSubmit}
    initialValues={initialValues}
    validate={validate}
    render={({ handleSubmit, reset, submitting, pristine, errors }) => (
      <form onSubmit={handleSubmit}>
        <FormGroup>
          <Field
            name="password"
            type="password"
            component={renderBootstrapField}
            label="Password"
            validate={required}
            warn={passwordStrength}
          />
        </FormGroup>
        <FormGroup>
          <Field
            name="password2"
            type="password"
            component={renderBootstrapField}
            label="Confirm Password"
          />
        </FormGroup>
        <FormGroup>
          <ButtonToolbar>
            <Button
              disabled={pristine || submitting}
              bsStyle="info"
              type="submit"
            >
              Set Password
            </Button>
            <Button
              onClick={onClose}
              bsStyle="info"
            >
              Nevermind
            </Button>
          </ButtonToolbar>
        </FormGroup>
      </form>
    )}
  />
  );

export default PasswordForm;



// WEBPACK FOOTER //
// src/routes/profile/components/PasswordForm.js